<template>
  <div>
    <div class="subject">
      <div class="subject-title">
        <input
          class="underline input-style"
          placeholder="標題"
          v-model="title"
          :disabled="!isEdit"
        />
      </div>
      <aside class="subject-tools">
        <div>
          <eva-icon
            v-if="!isEdit"
            fill="#5B5B5B"
            class="icon"
            name="edit-outline"
            @click="isEdit = true"
          />
          <eva-icon
            fill="#5B5B5B"
            class="icon"
            name="trash-2-outline"
            @click="del"
          />
        </div>
      </aside>
    </div>
    <input
      v-if="hasDescription"
      class="underline description-style"
      placeholder="備註說明"
      v-model="description"
      :disabled="!isEdit"
    />
    <div v-if="isEdit" class="tag-group">
      <span
        class="badge tag"
        :style="[
          isRequired ? { background: '#3DBA90' } : { background: '#BDBDBD' },
        ]"
        @click="isRequired = !isRequired"
      >
        <eva-icon fill="#fff" name="star-outline" class="icon" />
        <span>必填</span>
      </span>
      <span
        class="badge tag"
        :style="[
          hasDescription
            ? { background: '#3DBA90' }
            : { background: '#BDBDBD' },
        ]"
        @click="hasDescription = !hasDescription"
      >
        <eva-icon fill="#fff" name="message-square-outline" class="icon" />
        <span>備註</span>
      </span>
    </div>
    <div class="answer">
      <textarea rows="5" class="basic style" disabled />
    </div>
    <div v-if="isEdit" class="button-group">
      <button type="button" class="btn btn-light btn-sm" @click="cancel">
        取消
      </button>
      <button type="button" class="btn btn-info btn-sm" @click="done">
        完成
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  name: "Input",

  data() {
    return {
      isEdit: true,
      title: null,
      isRequired: false,
      hasDescription: false,
      description: null,
    };
  },
  methods: {
    // 刪除
    del() {
      this.$emit("delItem", this.data);
    },

    // 完成
    done() {
      const data = {
        id: this.data.id,
        ColumnType: "textarea",
        name: this.data.name,
        Title: this.title,
        require: this.isRequired,
        Description: this.hasDescription ? this.description : null,
      };
      this.isEdit = false;
      this.$emit("addItem", data);
    },

    // 取消
    cancel() {
      this.$emit("delItem", this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.subject {
  display: flex;
  position: relative;
  margin-bottom: 10px;

  .subject-title {
    width: 100%;
    input:focus {
      border-bottom: 2px solid #000;
    }
    .input-style {
      display: block;
      width: 100%;
      height: 30px;
      padding: 6px 12px;
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      box-shadow: none;
      box-sizing: border-box;
    }
  }
  .subject-tools {
    display: block;
    /deep/ svg {
      width: 20px;
      height: 20px;
    }
  }
  .subject-tools div {
    display: flex;
    flex: 1 1 15%;
    height: 30px;
    border-bottom: 1px solid #d2d2d2;
    .icon {
      flex: 1 1;
      cursor: pointer;
      padding: 2px 5px;
    }
  }
}
.description-style {
  display: block;
  width: 100%;
  height: 30px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  border: none;
  box-shadow: none;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.tag-group {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .tag {
    cursor: pointer;
    color: #fff;
    background: #bdbdbd;
    margin-right: 5px;
    padding: 4px 6px;
    span {
      margin-left: 3px;
      vertical-align: middle;
    }
  }
  /deep/ svg {
    width: 15px;
    height: 15px;
    vertical-align: middle;
  }
}
.answer {
  display: block;
  margin-bottom: 10px;
  .basic {
    width: 100%;
    color: #454545;
    border: 1px solid #d2d2d2;
    border-radius: 4px;
    background-color: #fff;
  }
}
.button-group {
  text-align: right;
  button:first-child {
    margin-right: 6px;
  }
}

.underline {
  color: #454545;
  border: none;
  border-bottom: 1px solid #d2d2d2;
}

input {
  outline: none;
}

input:focus {
  border-bottom: 2px solid #000;
}
</style>
